import React from 'react';
import { 
    Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter,  
} from 'reactstrap';
// TOAST

import UserList from '../UserList/UserList.js';

export default class ModalUserList extends React.Component {
  constructor(){
    super();
    this.initialState = {
    	tenantData : null
    }
    this.state = Object.assign({}, this.initialState)
  }

  willUnMount(){
  }

  componentWillReceiveProps(nextProps){
  	if (nextProps.tenantData != null){
  		this.setState({ tenantData : nextProps.tenantData})
  	}
  }

  render(){
    if(this.state.tenantData == null){
        return(null)
    }
    return(
      <Modal
      	isOpen={this.props.isOpen}
      	onExit={this.willUnMount.bind(this)} 
      	toggle={this.props.closeModal} 
      	className="modal-md"
      >
        <ModalHeader toggle={this.props.closeModal}>
          User List
          &nbsp;
          <small>for Tenant</small>
          &nbsp;
          {this.props.tenantData.name}
        </ModalHeader>
        <ModalBody>
            <div className="row">
                <div className="col-md-12">
                    <UserList 
                    	UserReducer={this.props.UserReducer} 
                    	tenantData={this.state.tenantData}
                    >
                    </UserList>
                </div>
            </div>
        </ModalBody>
        <ModalFooter>
            <button type="button" className="btn btn-danger" onClick={this.props.closeModal}>Close</button>
        </ModalFooter>
      </Modal>
  	)
  }
}


// WEBPACK FOOTER //
// ./src/App/tenant/tenant/helper/component/Modal/ModalUserList.js